import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function ClientNurs() {
  return (
    <section className="p-100">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              <span style={{ color: "#00ADEF" }}>The Client</span> Had?
            </h2>
            <p>
              The client initially had an idea to build a dedicated social
              networking platform where people could interact with their loved
              ones without any distractions or irrelevant feeds.
            </p>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-md-2"
          >
            <StaticImage
              src="../../../images/case-studies/selah/tek_img_04.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={570}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientNurs;
